import { StateObject } from '~src/domains/common/types/common';

const showResendLinkSelector = (state: StateObject) =>
  state.verify.showResendLink;

const verifyFormSelector = (state: StateObject) => state.verifyForm;

export { showResendLinkSelector, verifyFormSelector };
